import React from 'react';
import classNames from 'classnames';
import { Text, fontWeightEnum, textVariantsEnum } from '@/components/Text';
import styles from './MetricTile.module.scss';

export const MetricTileComponent = ({
  icon,
  value,
  label,
  tint = 'purple',
  className,
}) => (
  <div
    className={classNames(styles.metricTile, className)}
    style={{ background: `var(--${tint}-50)` }}
  >
    <span
      className={styles.iconBadge}
      style={{ background: `var(--${tint}-100)` }}
    >
      {icon}
    </span>
    <div className={styles.textCol}>
      <Text variant={textVariantsEnum.Text_lg} fontWeight={fontWeightEnum.Bold}>
        {value}
      </Text>
      <Text variant={textVariantsEnum.Text_xs} color="gray-500">
        {label}
      </Text>
    </div>
  </div>
);

MetricTileComponent.displayName = 'MetricTile';
